// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pathDetails-PathDetails-module__heightgraphContainer {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.src-pathDetails-PathDetails-module__innerDiv {
    position: relative;
    pointer-events: auto;
    background-color: white;
    border-radius: 0.4rem 0 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/pathDetails/PathDetails.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,2BAA2B;AAC/B","sourcesContent":[".heightgraphContainer {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n}\n\n.innerDiv {\n    position: relative;\n    pointer-events: auto;\n    background-color: white;\n    border-radius: 0.4rem 0 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heightgraphContainer": `src-pathDetails-PathDetails-module__heightgraphContainer`,
	"innerDiv": `src-pathDetails-PathDetails-module__innerDiv`
};
export default ___CSS_LOADER_EXPORT___;
